var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAudioOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_8061)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.22 1.25618C10.05 1.17618 9.85 1.19618 9.7 1.30618L5.83 4.20618H3C1.62 4.20618 0.5 5.32618 0.5 6.70618V9.70618C0.5 11.0862 1.62 12.2062 3 12.2062H5.83L9.7 15.1062C9.79 15.1762 9.89 15.2062 10 15.2062C10.08 15.2062 10.15 15.1862 10.22 15.1562C10.39 15.0662 10.5 14.8962 10.5 14.7062V1.70618C10.5 1.51618 10.39 1.34618 10.22 1.25618ZM16.5 8.20618C16.5 10.2252 15.749 12.0672 14.522 13.4772C14.333 13.6942 13.996 13.7022 13.792 13.4982C13.604 13.3102 13.597 13.0122 13.771 12.8122C14.851 11.5812 15.5 9.97718 15.5 8.20618C15.5 6.43518 14.851 4.83118 13.771 3.59918C13.597 3.40018 13.604 3.10218 13.792 2.91418C13.996 2.71018 14.333 2.71818 14.522 2.93518C15.749 4.34518 16.5 6.18718 16.5 8.20618ZM12.399 11.3422C13.087 10.4812 13.5 9.39217 13.5 8.20617C13.5 7.02017 13.087 5.93117 12.399 5.07017C12.219 4.84417 11.884 4.82217 11.68 5.02617L11.649 5.05617C11.474 5.23217 11.467 5.51017 11.621 5.70517C12.169 6.39417 12.5 7.26317 12.5 8.20617C12.5 9.14917 12.169 10.0182 11.621 10.7072C11.467 10.9022 11.474 11.1802 11.649 11.3552L11.68 11.3862C11.884 11.5902 12.219 11.5672 12.399 11.3422Z",
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_8061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.20752)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioOn);
export default __webpack_public_path__ + "static/media/icon-audio-on.f9a913dea9fe031942c960af70f2cb3d.svg";
export { ForwardRef as ReactComponent };